<template>
  <el-container style="height: 100vh; border: 1px solid #eee">
    <el-aside width="250px">
      <div class="pl15 pt15 pb15 flex items-center">
        <svg viewBox="0 0 24 24" style="width: 45px;"><g><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"></path></g></svg>
        <div class="ml10 bold fs20 mt15" style="color: #636576;">打包平台</div>
      </div>
      <el-menu
        :default-active="activeMenu"
        class="el-menu-vertical-demo" @select="handleSelect">
        <el-menu-item index="1">
          <div class="pl10 pr10 pt3 pb3">
            <div class="br10 flex items-center pl15 m-nav-item">
              <i class="el-icon-menu"></i>
              <div class="flex items-center" slot="title" style="height: 44px;">Apps</div>
            </div>
          </div>
        </el-menu-item>
        <el-menu-item index="2">
          <div class="pl10 pr10 pt3 pb3">
            <div class="br10 flex items-center pl15 m-nav-item">
              <i class="el-icon-orange"></i>
              <div class="flex items-center" slot="title" style="height: 44px;">渠道</div>
            </div>
          </div>
        </el-menu-item>
        <el-menu-item index="3">
          <div class="pl10 pr10 pt3 pb3">
            <div class="br10 flex items-center pl15 m-nav-item">
              <i class="el-icon-position"></i>
              <div class="flex items-center" slot="title" style="height: 44px;">签名</div>
            </div>
          </div>
        </el-menu-item>
        <el-menu-item index="4">
          <div class="pl10 pr10 pt3 pb3">
            <div class="br10 flex items-center pl15 m-nav-item">
              <i class="el-icon-s-promotion"></i>
              <div class="flex items-center" slot="title" style="height: 44px;">打包</div>
            </div>
          </div>
        </el-menu-item>
        
      </el-menu>
    </el-aside>
    
    <el-container>
      <el-header style="text-align: right;">
        <div class="mt30">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item><a href="/">首页</a></el-breadcrumb-item>
            <el-breadcrumb-item><a href="/">活动管理</a></el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-header>
      
      <el-main>
        <router-view/>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'HomeView',
  data() {
    return {
      activeMenu: "1",
      menus: {
        "1": "/",
        "2": "/channel",
        "3": "/sign",
        "4": "/tasks",
      }
    }
  },
  created() {
    let path = document.baseURI.substring(document.baseURI.lastIndexOf("/"));
    for (let key in this.menus) {
      if (this.menus[key] == path) {
        this.activeMenu = key;
        break;
      }
    }
  },
  methods: {
    handleSelect(key) {
      if (this.activeMenu != key) {
        this.$router.push(this.menus[key])
        this.activeMenu = key;
      }
    }
  }
}
</script>


<style>
.el-menu-vertical-demo {
  background-color: transparent!important;
}
.el-menu-vertical-demo>.el-menu-item {
  padding: 0!important;
  height: 50px;
}
.el-menu-vertical-demo>.el-menu-item.is-active>div>.m-nav-item {
  background-color: #676cf6;
  color: white!important;
}

.m-nav-item {
  color: #636576;
}
.m-nav-item:hover {
  background-color: #eaeaed;
  color: #636576;
}
.el-main {
  padding-left: 0px!important;
}
</style>